import { Button, DatePicker, message, Space, Table, Checkbox, Input, Tag } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { fmtDate, strDate2Server } from "../../extensions/convert";
import { renderCheckbox } from "../../extensions/helper";
import { useSelector } from "react-redux";
import LicenseOrder from "./license-order";

const LicenseOrders = () => {
  // Загружаем сохраненные параметры из localStorage
  const getSavedFilter = () => {
    try {
      const saved = localStorage.getItem('licenseOrders');
      if (saved) {
        const parsed = JSON.parse(saved);
        return {
          dateBeg: parsed.dateBeg ? dayjs(parsed.dateBeg) : dayjs(),
          dateEnd: parsed.dateEnd ? dayjs(parsed.dateEnd) : dayjs(),
          allCompanies: parsed.allCompanies || false,
        };
      }
    } catch (e) {
      console.error('Error loading saved filter:', e);
    }
    return {
      dateBeg: dayjs(),
      dateEnd: dayjs(),
      allCompanies: false,
    };
  };

  const [filter, setFilter] = useState(getSavedFilter);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null); // accId выбранной записи (0 для нового)
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [searchText, setSearchText] = useState("");
  const user = useSelector((s) => s.user);

  const getData = () => {
    setLoading(true);
    let url = `license/orders?dateBeg=${strDate2Server(filter.dateBeg)}&dateEnd=${strDate2Server(filter.dateEnd)}&allCompanies=${filter.allCompanies}`;
    if (searchText.trim()) {
      url += `&searchText=${encodeURIComponent(searchText.trim())}`;
    }
    serverFetch(url)
      .then((data) => {
        setLoading(false);
        setItems(data);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(getData, []);

  const handlePay = async (record) => {
    try {
      setLoading(true);
      const response = await serverFetch('license/payOrder', {
        method: 'POST',
        bodyData: record,
      });
      
      setLoading(false);
      
      if (response && response.url) {
        // Открываем URL в новой вкладке
        window.open(response.url, '_blank');
      } else {
        message.error('Не получен URL для оплаты');
      }
    } catch (e) {
      setLoading(false);
      message.error(e.userMessage || 'Ошибка при инициации оплаты');
    }
  };

  const columns = [
    { dataIndex: "accId", title: "#", width: 60 },
    ...(user?.admin ? [{ dataIndex: "companyName", title: "Компания", width: 200 }] : []),
    { dataIndex: "createDate", title: "Дата", render: fmtDate },
    { dataIndex: "progName", title: "Программа" },
    { dataIndex: "licenseName", title: "Лицензия" },
    { dataIndex: "licDuration", title: "Срок" },
    { dataIndex: "qty", title: "Кол." },
    { dataIndex: "summ", title: "Сумма" },
    // { dataIndex: "keyWord", title: "Кодовое слово", render: renderCheckbox },
    { 
      dataIndex: "payDate", 
      title: "Оплачен", 
      render: (value, record) => {
        if (!value) {
          return (
            <Button 
              type="primary" 
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                handlePay(record);
              }}
            >
              Оплатить
            </Button>
          );
        }
        if (record.receipt) {
          return (
            <Tag 
              color="green" 
              style={{ cursor: 'pointer' }}
              onClick={(e) => {
                e.stopPropagation();
                window.open(record.receipt, '_blank');
              }}
            >
              {fmtDate(value)}
            </Tag>
          );
        }
        return fmtDate(value);
      }
    },
    // { dataIndex: "payName", title: "Способ оплаты" },
    { dataIndex: "komment", title: "Комментарий" },
  ];

  const onFilterChange = (value) => {
    const newFilter = { ...filter, ...value };
    setFilter(newFilter);
    
    // Сохраняем параметры в localStorage
    try {
      const toSave = {
        dateBeg: newFilter.dateBeg?.format('YYYY-MM-DD'),
        dateEnd: newFilter.dateEnd?.format('YYYY-MM-DD'),
        allCompanies: newFilter.allCompanies,
      };
      localStorage.setItem('licenseOrders', JSON.stringify(toSave));
    } catch (e) {
      console.error('Error saving filter:', e);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      getData();
    }
  };

  const onRowClick = (record) => {
    setSelected(record.accId);
    setSelectedCompanyId(record.companyId);
  };

  const handleModalClose = refresh => {
    setSelected(null);
    setSelectedCompanyId(null);
    refresh && getData();
  };

  return (
    <div className="page">
      <Space>
        <div>Период с</div>
        <DatePicker format="DD.MM.YYYY" value={filter.dateBeg} onChange={(e) => onFilterChange({ dateBeg: e })} allowClear={false}/>
        <div>по</div>
        <DatePicker format="DD.MM.YYYY" value={filter.dateEnd} onChange={(e) => onFilterChange({ dateEnd: e })} allowClear={false}/>
        {user?.admin && <Checkbox checked={filter.allCompanies} onChange={(e) => onFilterChange({ allCompanies: e.target.checked })}>По всем компаниям</Checkbox>}
        <Input
          placeholder="Поиск по телефону, почте, наименованию, ИНН"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyPress={handleKeyPress}
          style={{ width: 400 }}
        />
        <Button type="primary" onClick={getData} loading={loading}>Обновить</Button>
        <Button onClick={() => { setSelected(0); setSelectedCompanyId(user?.companyId); }} disabled={loading}>Новый</Button>
      </Space>
      <Table 
        columns={columns} 
        dataSource={items} 
        loading={loading} 
        rowKey={(record) => `${record.companyId}-${record.accId}`} 
        style={{ marginTop: 16 }} 
        pagination={false} 
        size="small"
        onRow={(record) => ({
          onClick: () => onRowClick(record),
          style: { cursor: 'pointer' }
        })}
      />      
      {selected != null && selectedCompanyId != null && (
        <LicenseOrder companyId={selectedCompanyId} accId={selected} onClose={handleModalClose} />
      )}
    </div>
  );
};

export default LicenseOrders;